import * as _4 from 'lodash4';
import { ConversationThread } from '../../src/builders/conversation_thread_builder';
import { ConversationThreadsQuery } from '../../src/queries/conversation_threads_query';

export class ConversationThreadServant {
  constructor(
    private ngConversationThreadsQuery: ConversationThreadsQuery,
    private ConversationThreadStatusEnum: any
  ) {}

  get firstThread(): ConversationThread {
    return _4.first(this.ngConversationThreadsQuery.result);
  }

  get lastThread(): ConversationThread | undefined {
    return _4.size(this.ngConversationThreadsQuery.result) > 1
      ? _4.last(this.ngConversationThreadsQuery.result)
      : undefined;
  }

  get intermediateThreads(): ConversationThread[] {
    return _4.slice(this.ngConversationThreadsQuery.result, 1, -1);
  }

  get unreadThreadIDs(): number[] {
    return _4.reduce(
      this.ngConversationThreadsQuery.result,
      (ids: number[], thread: ConversationThread) => {
        if (this.ConversationThreadStatusEnum.isUnread(thread.status)) {
          ids.push(thread.id);
        }
        return ids;
      },
      []
    );
  }

  hasIntermediateThreads(): boolean {
    return _4.size(this.intermediateThreads) > 0;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-conversations/src/servants/conversation_thread_servant.ts